"use client";

import { trackClickEvent } from "@homeinstead/analytics";
import ArrowRounded from "@homeinstead/icons/ArrowRounded";
import { Link } from "@homeinstead/ui/components/Link";

interface VideoPlayButtonProps {
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const VideoPlayButton = ({ onClick }: VideoPlayButtonProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Track the click event before calling the custom onClick handler
    trackClickEvent("video_play_button", {
      target_url: "#video-primary",
    });

    // Call the custom onClick handler if provided
    onClick?.(e);
  };

  return (
    <Link
      className="absolute top-[80%] left-1/2 block -translate-x-1/2 -translate-y-1/2"
      href="#video-primary"
      onClick={handleClick}
      variant="secondary"
    >
      <div className="flex items-center gap-2">
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-new-beginnings-base">
          <ArrowRounded className="h-3 w-3 rotate-180 text-friendly-base" />
        </div>
        <span>Watch video</span>
      </div>
    </Link>
  );
};
